export const formatAmount = (amount) => {
    if (amount < 100) {
      return `${amount} lakh`;
    } else {
      const crore = (amount / 100).toFixed(1);
      return crore.endsWith('.0') ? `${Math.floor(amount / 100)} Cr` : `${crore} cr`;
    }
  };
  